import { BasicDoctorInfo } from "@elixir/types";
import { SearchBarComponentUi } from "ui";

export const DoctorSearch = ({
  inputValue,
  setInputValue,
  list = [],
  setSelectedDoctor,
  selectedDoctor,
}: {
  list: BasicDoctorInfo[];
  inputValue: string;
  selectedDoctor: BasicDoctorInfo | undefined;
  setInputValue: React.Dispatch<React.SetStateAction<string>>;
  setSelectedDoctor: (doctor: BasicDoctorInfo | undefined) => void;
}) => {
  return (
    <div className="dr-w-250 dr-overflow-hidden dr-rounded-b-8">
      <SearchBarComponentUi
        className="dr-rounded-8 dr-border-transparent"
        placeholder="Search Doctor"
        onChange={(e) => {
          setInputValue(e.target.value);
        }}
        inputValue={inputValue}
      />
      <div className="dr-h-1 dr-w-full dr-bg-darwin-neutral-200"></div>
      <div className="dr-max-h-500 dr-overflow-y-scroll">
        {list.map((doctor) => (
          <DoctorTile
            isSelected={selectedDoctor?.oid === doctor.oid}
            onClick={() => setSelectedDoctor(doctor)}
            key={doctor.oid}
            doctor={doctor}
          />
        ))}
      </div>
    </div>
  );
};

const DoctorTile = ({
  isSelected = false,
  doctor,
  onClick,
}: {
  isSelected: boolean;
  doctor: BasicDoctorInfo;
  onClick: () => void;
}) => {
  return (
    <button
      onClick={onClick}
      className={`dr-cursor-pointer dr-w-full dr-flex dr-items-center dr-space-x-8 dr-py-8 dr-px-16 ${
        isSelected
          ? "dr-bg-darwin-primary-bg-light"
          : "hover:dr-bg-darwin-neutral-50"
      }`}
    >
      <img
        className="dr-w-36 dr-h-36 dr-rounded-full"
        src={doctor.pic}
        alt={doctor.name}
      />
      <div className="dr-line-clamp-1">{doctor.name}</div>
    </button>
  );
};
